import { ReactPropTypes } from "react";
import { Link } from "react-router-dom";

interface PageListWidgetProps {
  widget: any;
}

const PageListWidget = ({ widget }: PageListWidgetProps) => {
  if (widget.Pages?.length > 0) {
    return (
      <ul className="list-unstyled d-grid gap-8 my-8">
        {widget.Pages.map((page) => {
          return (
            <li key={"p-" + page.contentItemId}>
              <Link
                className=""
                to={"https://www.lomarengas.fi" + page.path}
                target="_blank"
              >
                {page.title}
              </Link>
            </li>
          );
        })}
      </ul>
    );
  }

  return null;
};

export default PageListWidget;
export type { PageListWidgetProps };
